import { Component, Prop,h} from '@stencil/core';

@Component({
  tag: 'oebb-tickets-icon',
  shadow: false
})
export class TicketsIcon {

    @Prop() svgStyle: any = {};
    @Prop() width: number = 16;
    @Prop() height: number = 20;

    render() {
        return (
        <oebb-icon>
            <svg style={this.svgStyle} width={this.width} height={this.height} fill="none" viewBox="0 0 16 20" role="img">
                <slot />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.975C0 0.89 0.908 0 2.018 0H10.091C11.201 0 12.109 0.889 12.109 1.975L12.108 2.996L14.282 3.283C15.317 3.419 16.06 4.29 15.996 5.253L15.981 5.399L14.037 18.387C13.884 19.407 12.87 20.125 11.783 19.982L3.879 18.939C3.53886 18.8982 3.21511 18.7699 2.9394 18.5666C2.66368 18.3633 2.44544 18.0919 2.306 17.779H2.018C0.908 17.779 0 16.889 0 15.803V1.975ZM7.717 17.779L10.997 18.209C11.801 18.316 12.56 17.731 12.684 16.909L14.254 6.465C14.376 5.645 13.819 4.886 13.014 4.781L12.108 4.662V15.803C12.108 16.84 11.281 17.697 10.241 17.773L10.091 17.779H7.717ZM11.244 7.111C11.244 6.53 11.604 6.037 12.108 5.854V8.369C11.8523 8.27335 11.6322 8.10131 11.4776 7.87625C11.323 7.65119 11.2415 7.38402 11.244 7.111ZM1.73 1.778H10.379V16H1.729L1.73 1.778ZM6.487 7.111C6.487 7.849 7.067 8.445 7.784 8.445C8.502 8.445 9.081 7.849 9.081 7.111C9.081 6.374 8.502 5.778 7.784 5.778C7.066 5.778 6.487 6.374 6.487 7.111ZM3.027 7.111C3.027 7.849 3.607 8.445 4.325 8.445C5.042 8.445 5.622 7.849 5.622 7.111C5.622 6.374 5.042 5.778 4.325 5.778C3.607 5.778 3.027 6.374 3.027 7.111ZM0.000999928 5.854C0.505 6.037 0.865 6.53 0.865 7.111C0.867653 7.38431 0.786041 7.65179 0.631267 7.87706C0.476493 8.10234 0.256074 8.27445 0 8.37L0.000999928 5.854Z" fill="currentColor"/>
            </svg>
        </oebb-icon>
        );
    }
}

